module.exports = __webpack_public_path__ + "img/icon-credit-card.170d3a45.svg";